export enum SortKeys {
  Status = "status",
  Model = "segment.name",
  Destination = "destination.name",
  LastRunAt = "last_run_at",
  UpdatedAt = "updated_at",
}

export const DEFAULT_SYNC_SORT_KEY = SortKeys.UpdatedAt;
export const SYNC_SORT_OPTIONS = Object.values(SortKeys);
